import { Store } from '@betgames/bg-state-manager';
import { balanceSelectors, balanceStore } from '@bg-shared/business/Balance';
import { StoresEntity } from '@bg-shared/business/StoreFeature';
import { GameId } from '@bg-shared/enums/GameId';

/**
 * Balance for RGS to show balance and validate changes immediately after clicking spin
 * and wait for increase after win animation
 */
export class RGSBalance extends Store<number> {
    private shouldSync = true;

    constructor(private readonly gameId: GameId) {
        super({
            key: `RGSBalance/${gameId}`,
            default: 0,
        });
    }

    private getCurrentBalance(): number {
        return balanceSelectors.getValue(this.gameId)(balanceStore.value);
    }

    private sync(): void {
        if (!this.shouldSync) {
            return;
        }

        this.update(this.getCurrentBalance());
    }

    public init(): () => void {
        this.toggleSync(true);
        this.sync();

        return balanceStore.subscribe(() => {
            this.sync();
        });
    }

    public toggleSync(value: boolean): RGSBalance {
        this.shouldSync = value;

        return this;
    }

    public applyChange(amount: number, force = false): RGSBalance {
        const currentBalance = this.getCurrentBalance();

        if (!force && currentBalance === this.value) {
            return this;
        }

        this.update((draft) => {
            return draft + amount;
        });

        return this;
    }
}

export const rgsBalanceEntity = new StoresEntity(RGSBalance);
